import React from "react";
import Navbar1 from "./Navbar";
import emailIcon from "../assets/contact/email.png";
import locationIcon from "../assets/contact/pin.png";
import phoneIcon from "../assets/contact/cel2.png";
import { Container } from "react-bootstrap";
import ImmagineCopertina from "../assets/contact/9 - Copia.png";

const Contact = () => {
  return (
    <>
      <Navbar1 />
      <div className="contact-page">
        <Container fluid style={{ padding: "0px", position: "relative", textAlign: "center" }}>
          <img
            src={ImmagineCopertina}
            alt="Copertina"
            className="img-fluid"
            id="responsive"
            style={{
              maxWidth: "100%",
              height: "20%",
            }}
          />
        </Container>

        <div className="container text-center" id="contact-form">
          <div className="row justify-content-center" style={{ marginTop: "20px", marginBottom: "40px" }}>
            <div className="col-md-4 mb-4">
              <div
                className="card p-3 h-100"
                style={{ backgroundColor: "#f6f6f6", color: "#663455", borderRadius: "0" }}
              >
                <div className="card-body d-flex flex-column align-items-center">
                  <div
                    className="icon"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "1rem",
                    }}
                  >
                    <img src={phoneIcon} alt="Email Icon" style={{ width: "50px" }} />
                  </div>
                  <p className="card-text" style={{ fontFamily: "Playfair Display, serif", color: "#b3870b" }}>
                    <strong>Telefono</strong>
                  </p>
                  <p
                    className="card-text"
                    style={{
                      fontSize: "1.0rem",
                      lineHeight: "1.6",
                      fontFamily: "Montserrat, sans-serif",
                      color: "black",
                    }}
                  >
                    +39 333 182 5767
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 mb-4">
              <a href="tel:+39123456789" style={{ textDecoration: "none" }}>
                {" "}
                <div
                  className="card p-3 h-100"
                  style={{ backgroundColor: "#f6f6f6", color: "#663455", borderRadius: "0" }}
                >
                  <div className="card-body d-flex flex-column align-items-center">
                    <div
                      className="icon"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: "1rem",
                      }}
                    >
                      <img src={emailIcon} alt="Phone Icon" style={{ width: "50px" }} />
                    </div>
                    <p className="card-text" style={{ fontFamily: "Playfair Display, serif", color: "#b3870b" }}>
                      <strong>Email</strong>
                    </p>
                    <p
                      className="card-text"
                      style={{
                        fontSize: "1.0rem",
                        lineHeight: "1.6",
                        fontFamily: "Montserrat, sans-serif",
                        color: "black",
                      }}
                    >
                      starblackgioielli@gmail.com
                    </p>
                  </div>
                </div>
              </a>
            </div>

            <div className="col-md-4 mb-4">
              <div
                className="card p-3 h-100"
                style={{ backgroundColor: "#f6f6f6", color: "#663455", borderRadius: "0" }}
              >
                <div className="card-body d-flex flex-column align-items-center">
                  <div
                    className="icon"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "1rem",
                    }}
                  >
                    <img src={locationIcon} alt="Location Icon" style={{ width: "50px" }} />
                  </div>
                  <p className="card-text" style={{ fontFamily: "Playfair Display, serif", color: "#b3870b" }}>
                    <strong>Indirizzo</strong>
                  </p>
                  <p
                    className="card-text"
                    style={{
                      fontSize: "1.0rem",
                      lineHeight: "1.6",
                      fontFamily: "Montserrat, sans-serif",
                      color: "black",
                    }}
                  >
                    Via Serra De Conti 62, Roma - 00138
                  </p>
                </div>
              </div>
            </div>
          </div>

          <h2 style={{ fontFamily: "Playfair Display", color: "black", marginTop: "30px" }}>Dove siamo</h2>
          <div className="map-responsive" style={{ marginTop: "20px" }}>
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyA0s1a7phLN0iaD6-UE7m4qP-z21pH0eSc&q=Via+Serra+De+Conti+62,+Roma+00138"
              width="600"
              height="400"
              frameBorder="0"
              style={{ border: 0, width: "100%", marginBottom: "20px" }}
              allowFullScreen
            ></iframe>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
